import React from 'react';
import { Form as AntdForm, FormInstance } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import styled from 'styled-components';

import theme from '~/constants/theme';
import colors from '~/constants/colors';
import FloatLabel from './FloatLabel';

interface Props<Values> extends FormItemProps<Values> {
  placeholder?: any;
  label?: string;
  disabled?: boolean;
}

type FormItemType<Values = any> = (props: Props<Values>) => React.ReactElement;

function FormItem<Values = any>(props: Props<Values>): React.ReactElement {
  const { children, label, rules = [], shouldUpdate, noStyle, disabled, required, ...rest } = props;
  // const { defaultValidator, disabled: disabledAll } = useFormItemContext();
  // const defaultRule: typeof rules = defaultValidator ? [{ validator: defaultValidator }] : [];
  const defaultRule: any[] = [];
  const disabledAll = false;

  if (shouldUpdate) {
    return (
      <AntdForm.Item shouldUpdate={shouldUpdate} noStyle>
        {(form) => (
          <AntdForm.Item rules={defaultRule.concat(rules)} noStyle={noStyle} {...rest}>
            <FloatLabel
              label={label}
              shouldUpdate={shouldUpdate}
              disabled={disabledAll || disabled}
              required={required}
            >
              {typeof children === 'function' ? (children as any)?.(form) : children}
            </FloatLabel>
          </AntdForm.Item>
        )}
      </AntdForm.Item>
    );
  }
  return (
    <AntdForm.Item rules={defaultRule.concat(rules)} noStyle={noStyle} {...rest}>
      <FloatLabel
        label={label}
        shouldUpdate={shouldUpdate}
        disabled={disabledAll || disabled}
        required={required}
      >
        {children as any}
      </FloatLabel>
    </AntdForm.Item>
  );
}

export type RenderChildren<Values = any> = (form: FormInstance<Values>) => React.ReactNode;

export default styled(FormItem)`
  .ant-form-item-explain {
    font-size: 12px;
    min-height: ${theme.formVerticalSpacing}px !important;
    transition: 0.2s ease-in color;
    &:not(.ant-form-item-explain-error) {
      margin-top: 0.6em;
    }
  }
  &:not(.ant-form-item-has-error) {
    .ant-input:focus,
    .ant-input-number:focus,
    .ant-input-number-focused,
    .ant-input-affix-wrapper,
    .ant-select-focused .ant-select-selector,
    .ant-picker-focused {
      border-color: ${colors.inputHoverBorderColor} !important;
      box-shadow: 0 0 0 2px ${colors.inputHoverBorderColor} !important;
    }
  }
` as FormItemType;
